<template >
  <v-flex xs12 sm12 md12 lg12 xl12>
    <Navbar></Navbar>
    <v-layout justify-center>
            <img class="hidden-xs-only" :src="portada" >
            <img class="hidden-sm-and-up" :src="portada" width="300px" height="79px">
        </v-layout>
    <v-container class="" >
      

      <v-layout justify-center>
        <v-flex sm4 md4 lg6 xl5 class="" >
          <!--<img src="buscador.png"  class="imgbuscador" />
          <input type="text" v-model="searchplaneacion" placeholder="Buscar Planeacion"/>-->
           <v-text-field 
            class="hidden-sm-and-md" 
            solo  
            label="Buscar Planeación"  
            v-model="searchplaneacion" 
            prepend-inner-icon="search"
            style="width:9s0%;" >
          </v-text-field>
        </v-flex>  
      </v-layout>

      <v-layout row wrap justify-center>
        <v-flex xs12 sm6 md6 lg6 xl5 v-for="file in filterPlaneaciones" :key="file.title">
          <v-card flat class="pa-3" style="background-color:#D6D6D6">        
            <v-img :src="file.img" width="100%">

              <v-layout align-center justify-center fill-height class="center">
                <v-card-actions >
                  <a :href="file.url" style="text-decoration:none" target="_blank" >
                    <v-btn slot="badge" flat color="#8A2663" style="font-family:Poppins;" >
                      <span>{{file.title}}</span>
                    </v-btn>
                  </a>
                </v-card-actions>
              </v-layout>
                   
              <v-layout align-end justify-end row fill-height class="downloadfile">
                <!--<v-flex xs1 sm1 md1 lg1 xl1 ></v-flex>-->
                <v-card-actions >
                  <a @click="downloadItem(file.url,file.namedownload)">
                    <img src="descargar.png" class="download hidden-sm-and-down" >
                    <img src="descargar.png" class="download hidden-md-and-up" width="50px" >
                  </a>
                </v-card-actions>
              </v-layout>

            </v-img>      
          </v-card>
        </v-flex>
      </v-layout>
  
    </v-container>
  </v-flex>
</template>

<script type="text/javascript">
  import Navbar from "@/components/Navbar.vue"
  import axios from 'axios'
 
  export default {
      components:{
          Navbar
      },

      data(){
        return{
          searchplaneacion:""
        }
      },
      
      props:['files','portada'],

     methods:{
       downloadItem (url,name) {
        axios.get(url, { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = name
            link.click()
          }).catch(error => console.error(error))
        }
  
        
},
computed: {
      filterPlaneaciones: function(){
        if (this.searchplaneacion=="") {
          return this.files
        }else{
          return this.files.filter((file)=>{
            var expresion = new RegExp(this.searchplaneacion,"i")
            return file.title.match(expresion)
          })
        }      
      }
  }
     }


    
  
</script>


<style scoped>

/*@media (min-width: 1100px){
input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    float:left;
    margin-left: 25px;
    
  }

  .imgbuscador{
    position:absolute;
    margin-left: -30px;
  }

}*/

@media (min-width: 700px){
.center span{
  font-size:1.5vw;  
}
}

@media (min-width: 300px) and (max-width: 700px){
.center span{
  font-size:4.2vw;  
}

}

/*@media (min-width: 750px) and (max-width: 1200px){

input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    float:left;
    margin-left: 25px;
    
  }

  .imgbuscador{
    position:absolute;
    margin-left: -30px;
  }

}

@media (min-width: 300px) and (max-width: 400px){

input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    float:left;
    margin-left: 32px;
    
  }

  .imgbuscador{
    position:absolute;
    margin-left: -15px;
  }


}


@media (min-width: 400px) and (max-width: 750px){


input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    float:left;
    margin-left: 38px;
    
  }

  .imgbuscador{
    position:absolute;
    margin-left: -15px;
  }
}*/
.downloadfile{
  position: absolute; bottom: -15px; right: -10px;
  width: 30px;
}

.download:hover {
  transform: scale(1.1); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

</style>
